/* eslint-disable no-nested-ternary */
import i18n from 'i18next';
import moment from 'moment-timezone';
import 'moment/locale/es';
// sadmin account_manager customer_success rm_admin
// broker admin
// insurer admin
// risk_engineer admin
// business_owner app_user
// company_admin site_manager site_supervisor app_user
function mapActions(roles) {
    const sadminRoles = ['sadmin', 'account_manager', 'customer_success', 'rm_admin'];
    const rolesIds = (roles === null || roles === void 0 ? void 0 : roles.map((a) => a.role_id)) || [];
    const canEditCompany = [...sadminRoles, 'business_owner', 'company_admin', 'site_manager', 'site_supervisor'];
    const canEditUser = ['sadmin', 'account_manager', 'customer_success', 'admin', 'business_owner', 'company_admin', 'site_manager', 'site_supervisor'];
    const canDeleteUser = ['sadmin', 'account_manager', 'customer_success', 'admin', 'business_owner', 'company_admin'];
    const canEditRiskProfile = [...sadminRoles];
    const canEditSite = [...sadminRoles, 'business_owner', 'company_admin', 'site_manager', 'site_supervisor', 'risk_engineer'];
    const canDisableSite = [...sadminRoles, 'company_admin'];
    const canEditActivity = [...sadminRoles, 'company_admin', 'risk_engineer'];
    const canDeleteActivity = ['sadmin', 'account_manager', 'customer_success', 'rm_admin'];
    const canReasignActivity = [...sadminRoles, 'company_admin', 'site_supervisor', 'site_manager', 'business_owner'];
    // const canApproveActivity = [...sadminRoles, 'business_owner', 'company_admin', 'site_manager', 'site_supervisor'];
    const canApproveActivity = ['marijo'];
    const canAccessSimulator = ['sadmin', 'rm_admin'];
    if (rolesIds === null || rolesIds === void 0 ? void 0 : rolesIds.length) {
        return {
            canEditCompany: canEditCompany.some((value) => rolesIds.includes(value)),
            canEditUser: canEditUser.some((value) => rolesIds.includes(value)),
            canDeleteUser: canDeleteUser.some((value) => rolesIds.includes(value)),
            canEditRiskProfile: canEditRiskProfile.some((value) => rolesIds.includes(value)),
            canEditSite: canEditSite.some((value) => rolesIds.includes(value)),
            canDisableSite: canDisableSite.some((value) => rolesIds.includes(value)),
            canEditActivity: canEditActivity.some((value) => rolesIds.includes(value)),
            canDeleteActivity: canDeleteActivity.some((value) => rolesIds.includes(value)),
            canReasignActivity: canReasignActivity.some((value) => rolesIds.includes(value)),
            canApproveActivity: canApproveActivity.some((value) => rolesIds.includes(value)),
            canAccessSimulator: canAccessSimulator.some((value) => rolesIds.includes(value)),
            canEditTrurisk: sadminRoles.some((value) => rolesIds.includes(value)),
        };
    }
    return {};
}
function mapIdentity(getIdentity) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    if ((_a = getIdentity === null || getIdentity === void 0 ? void 0 : getIdentity.data) === null || _a === void 0 ? void 0 : _a.getPlatformUser) {
        const identity = getIdentity.data.getPlatformUser;
        if (i18n && (i18n === null || i18n === void 0 ? void 0 : i18n.language) !== identity.localization) {
            i18n.changeLanguage(identity.localization);
        }
        if (identity.localization) {
            moment.locale(identity.localization);
        }
        return {
            id: identity.id,
            name: identity.name,
            email: identity.email,
            username: identity.username,
            avatar_image: identity.avatar_image,
            tou_accepted: identity.tou_accepted,
            localization: identity.localization,
            services: identity.account ? identity.account.services : 0,
            account_id: ((_b = identity === null || identity === void 0 ? void 0 : identity.account) === null || _b === void 0 ? void 0 : _b.id) || '',
            account_name: identity.account ? identity.account.name : '',
            accountTier: ((_c = identity === null || identity === void 0 ? void 0 : identity.account) === null || _c === void 0 ? void 0 : _c.tier) || 1,
            custom_activities: (identity.roles && identity.roles.some((a) => a.role_id === 'sadmin')) || ((_e = (_d = identity === null || identity === void 0 ? void 0 : identity.account) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.custom_activities),
            companies: ((_g = (_f = identity.account) === null || _f === void 0 ? void 0 : _f.companies) === null || _g === void 0 ? void 0 : _g.length) ? identity.account.companies : [],
            locations: (identity === null || identity === void 0 ? void 0 : identity.locations) || [],
            current_company_id: ((_j = (_h = identity.account) === null || _h === void 0 ? void 0 : _h.companies) === null || _j === void 0 ? void 0 : _j.length) ? identity.account.companies[0].id : '',
            current_company: ((_l = (_k = identity.account) === null || _k === void 0 ? void 0 : _k.companies) === null || _l === void 0 ? void 0 : _l.length) ? identity.account.companies[0] : {},
            current_location: ((_m = identity.locations) === null || _m === void 0 ? void 0 : _m.length)
                ? identity.locations[0]
                : ((_p = (_o = identity.account) === null || _o === void 0 ? void 0 : _o.companies) === null || _p === void 0 ? void 0 : _p.length) && ((_s = (_r = (_q = identity.account) === null || _q === void 0 ? void 0 : _q.companies[0]) === null || _r === void 0 ? void 0 : _r.locations) === null || _s === void 0 ? void 0 : _s.length)
                    ? identity.account.companies[0].locations[0]
                    : {},
            policy_lapsed: ((_u = (_t = identity.account) === null || _t === void 0 ? void 0 : _t.companies) === null || _u === void 0 ? void 0 : _u.length) ? identity.account.companies[0].policy_lapsed : false,
            roles: identity.roles,
            rolesIds: ((_v = identity.roles) === null || _v === void 0 ? void 0 : _v.map((r) => r.role_id)) || [],
            sadmin: identity.roles && identity.roles.some((a) => a.role_id === 'sadmin'),
            actions: mapActions(identity.roles),
            isHowden: ((_x = (_w = identity.account) === null || _w === void 0 ? void 0 : _w.config) === null || _x === void 0 ? void 0 : _x.customization) === 'Howden' || (((_z = (_y = identity.account) === null || _y === void 0 ? void 0 : _y.companies) === null || _z === void 0 ? void 0 : _z.length) && identity.account.companies[0].is_howden_client),
            // admin:
            //   identity.roles &&
            //   identity.roles.some(
            //     (a: any) => a.role_id === 'admin' || a.role_id === 'site_manager' || a.role_id === 'business_owner' || a.role_id === 'risk_manager'
            //   ),
        };
    }
    return emptyIdentity();
}
function emptyIdentity() {
    return {
        id: '',
        name: '',
        email: '',
        username: '',
        avatar_image: '',
        account_id: '',
        accountTier: 1,
        current_company_id: '',
        policy_lapsed: false,
        current_company: {},
        current_location: {},
        account_name: '',
        services: 0,
        sadmin: false,
        // admin: false,
        roles: [],
        rolesIds: [],
        locations: [],
        companies: [],
        tou_accepted: false,
        localization: 'en',
        custom_activities: false,
        actions: {},
        isHowden: false,
    };
}
export { mapIdentity, emptyIdentity };
